module.exports = __webpack_public_path__ + "static/img/sence2.88171f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/feature6/sence2.png
// module id = vu1d
// module chunks = 7